import * as React from 'react';

import { Button, ButtonToolbar, Dropdown } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LinkContainer } from 'react-router-bootstrap';
import { constants } from '../../constants/constants';
import i18next from 'i18next';
import { jobTypesIdEnum } from '../../models-enums';
import { Iuser } from '../../models';
import { WithTranslation, withTranslation } from 'react-i18next';
import { downloadAppState, startSync } from '../../actions/commonActions';
import OnlineIndicatorButton from './OnlineIndicatorButton';
import { toastr } from 'react-redux-toastr';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsJobReadOnly } from '../../reducers/commonSelectors';
import { clearSelectedWorkOrderID, clearSelectedJob } from '../../actions/workOrderActions';
import { faClock } from '@fortawesome/free-solid-svg-icons';

interface Iprops {
    toggle: (isOpen: boolean) => void;
    handleMenuSelect: (eventKey: any) => void;
    menuClass: string;
    jobType: jobTypesIdEnum;
    hasJob: boolean;
    offlineStatusOverride: boolean;
    online: boolean;
    user: Iuser;
    loading: boolean;
    startSync: typeof startSync;
    downloadAppState: typeof downloadAppState;
    isAPIQueueEmpty: boolean;
}

const DropDownMenu: React.FC<Iprops & WithTranslation> = props => {
    const assetsRoute = '/devices';
    const dispatch = useDispatch();
    const isJobReadOnly = useSelector(selectIsJobReadOnly);
    // const isMobile = useSelector(getIsMobile);

    const allowedToSeeNPH = () => {
        // 8/25/23 - only disabling if user belongs to UK
        // If user has more than one country, they would have another country besides UK so they are good
        if (props.user.userCountries.length === 1) {
            if (props.user.userCountries[0] === constants.ukCountryID) {
                return false;
            }
        }

        return true;
    };

    return (
        <ButtonToolbar className="header-menu">
            <Dropdown onToggle={props.toggle} id="header-dropdown" onSelect={props.handleMenuSelect}>
                <Dropdown.Toggle variant="link" className="header-menu-button" size="sm">
                    <FontAwesomeIcon icon={['far', 'bars']} size="lg" />
                </Dropdown.Toggle>

                <Dropdown.Menu className={props.menuClass}>
                    {/* Mobile only container */}
                    <li className="menu-welcome">
                        <div className="menu-wecome-left">
                            <p className="welcome-text-menu">{String(i18next.t('welcome'))}</p>

                            <p className="name-menu">{props.user.first}</p>
                        </div>
                        <div className="menu-welcome-right">
                            <OnlineIndicatorButton doubleClick={props.downloadAppState} online={props.online} />

                            <Button
                                type="button"
                                variant="default"
                                disabled={props.loading}
                                onClick={() => {
                                    if (!props.online) {
                                        toastr.warning(
                                            i18next.t('toastMessage:offline'),
                                            i18next.t('toastMessage:onlineRequired'),
                                            constants.toastrWarning
                                        );
                                        return;
                                    }
                                    props.startSync();
                                }}
                                size="sm"
                            >
                                {String(i18next.t('sync'))}
                            </Button>
                        </div>
                    </li>
                    <LinkContainer
                        to={'/jobs'}
                        onClick={e => {
                            if (!props.online) {
                                e.preventDefault();
                            }
                        }}
                    >
                        <Dropdown.Item
                            disabled={!props.online}
                            onClick={evt => {
                                if (props.online) {
                                    dispatch(clearSelectedWorkOrderID()); // what does this even do?
                                    dispatch(clearSelectedJob());
                                }
                            }}
                        >
                            <React.Fragment>
                                <FontAwesomeIcon icon={['far', 'exchange']} fixedWidth /> &nbsp;{' '}
                                {String(i18next.t('common:switchJobs'))}
                            </React.Fragment>
                        </Dropdown.Item>
                    </LinkContainer>
                    {props.hasJob && (
                        <LinkContainer to={assetsRoute}>
                            <Dropdown.Item>
                                <React.Fragment>
                                    <FontAwesomeIcon icon={['far', 'clipboard-list']} fixedWidth /> &nbsp;{' '}
                                    {props.jobType === jobTypesIdEnum.repair &&
                                        String(i18next.t('manageWorkOrder:bannerTitle'))}
                                    {props.jobType !== jobTypesIdEnum.repair &&
                                        String(i18next.t('common:manageInventory'))}
                                </React.Fragment>
                            </Dropdown.Item>
                        </LinkContainer>
                    )}
                    {props.hasJob && !isJobReadOnly && (
                        <LinkContainer to={'/locations'}>
                            <Dropdown.Item>
                                <React.Fragment>
                                    <FontAwesomeIcon icon={['far', 'building']} fixedWidth /> &nbsp;{' '}
                                    {String(i18next.t('common:manageLocations'))}
                                </React.Fragment>
                            </Dropdown.Item>
                        </LinkContainer>
                    )}
                    {props.hasJob && !isJobReadOnly && props.jobType === jobTypesIdEnum.maintenance && (
                        <LinkContainer to={'/maintenance'}>
                            <Dropdown.Item>
                                <React.Fragment>
                                    <FontAwesomeIcon icon={['far', 'cogs']} fixedWidth /> &nbsp;{' '}
                                    {String(i18next.t('manageWorkOrder:maintenanceTabTitle'))}
                                </React.Fragment>
                            </Dropdown.Item>
                        </LinkContainer>
                    )}
                    {props.hasJob &&
                        !isJobReadOnly &&
                        (props.jobType === jobTypesIdEnum.repair ||
                            props.jobType === jobTypesIdEnum.servicePlan ||
                            props.jobType === jobTypesIdEnum.commissioning) && (
                            <LinkContainer to={'/repair'}>
                                <Dropdown.Item>
                                    <React.Fragment>
                                        <FontAwesomeIcon icon={['fas', 'tools']} fixedWidth /> &nbsp;{' '}
                                        {String(i18next.t('manageInventory:bannerTitleMobileWorkOrderMode'))}
                                    </React.Fragment>
                                </Dropdown.Item>
                            </LinkContainer>
                        )}

                    {props.hasJob && !isJobReadOnly && props.jobType === jobTypesIdEnum.warrantyBM && (
                        <LinkContainer to={'/warranty'}>
                            <Dropdown.Item>
                                <React.Fragment>
                                    <FontAwesomeIcon icon={['far', 'shield-check']} fixedWidth /> &nbsp;{' '}
                                    {String(i18next.t('manageInventory:warranty'))}
                                </React.Fragment>
                            </Dropdown.Item>
                        </LinkContainer>
                    )}
                    <hr className="menu-break" />
                    {props.hasJob === false && allowedToSeeNPH() && (
                        <Dropdown.Item eventKey="5">
                            <React.Fragment>
                                <FontAwesomeIcon icon={faClock} fixedWidth /> &nbsp;{' '}
                                {String(i18next.t('common:recordNonProductiveHours'))}
                            </React.Fragment>
                        </Dropdown.Item>
                    )}
                    <Dropdown.Item eventKey="1">
                        <React.Fragment>
                            <FontAwesomeIcon icon="user" fixedWidth /> &nbsp; {String(i18next.t('common:profile'))}
                        </React.Fragment>
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="3">
                        <React.Fragment>
                            <FontAwesomeIcon icon={['far', 'sign-out']} fixedWidth /> &nbsp;{' '}
                            {String(i18next.t('common:logout'))}
                        </React.Fragment>
                    </Dropdown.Item>
                    <small
                        style={{
                            color: constants.colors.greyText,
                            padding: '5px 5px 5px 22px'
                        }}
                    >
                        v: {process.env.REACT_APP_VERSION}
                    </small>
                </Dropdown.Menu>
            </Dropdown>
        </ButtonToolbar>
    );
};

export default withTranslation('common')(DropDownMenu);
